import { render, staticRenderFns } from "./next-notification.vue?vue&type=template&id=d21b1a52&"
import script from "./next-notification.vue?vue&type=script&lang=js&"
export * from "./next-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports